export default {"src":"/_next/static/media/Plus_Brand.bfc2d31d.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};